"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/dialog.ts
var _dialog = require('@ariakit/react-core/dialog/dialog');
var _dialogcontext = require('@ariakit/react-core/dialog/dialog-context');
var _dialogdescription = require('@ariakit/react-core/dialog/dialog-description');
var _dialogdisclosure = require('@ariakit/react-core/dialog/dialog-disclosure');
var _dialogdismiss = require('@ariakit/react-core/dialog/dialog-dismiss');
var _dialogheading = require('@ariakit/react-core/dialog/dialog-heading');
var _dialogprovider = require('@ariakit/react-core/dialog/dialog-provider');
var _dialogstore = require('@ariakit/react-core/dialog/dialog-store');










exports.Dialog = _dialog.Dialog; exports.useDialogContext = _dialogcontext.useDialogContext; exports.DialogDescription = _dialogdescription.DialogDescription; exports.DialogDisclosure = _dialogdisclosure.DialogDisclosure; exports.DialogDismiss = _dialogdismiss.DialogDismiss; exports.DialogHeading = _dialogheading.DialogHeading; exports.DialogProvider = _dialogprovider.DialogProvider; exports.useDialogStore = _dialogstore.useDialogStore;
